export const WHATSAPP_NUMBER = '233245258723';

export const SHOP_PRODUCTS = [
  {
    id: 1,
    name: 'A4 Photo Frame – Walnut',
    description: 'Elegant walnut‑finish frame for A4 photos. Perfect for portraits, landscapes, and art prints.',
    image: 'https://lh3.googleusercontent.com/d/1nO0aDCEokaYRbU3229r9D64d2EkWA95V',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 2,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/19-r8wB7akHqTD-rqqJDIStCiQKJgGG6O',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 3,
    name: 'Digital Frame Template – A4',
    description: 'Editable digital frame template for social media posts, presentations, and digital portfolios.',
    image: 'https://lh3.googleusercontent.com/d/1fjEwZMSf_r3t4H22kTqjPmJBOkLPOLhH',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 4,
    name: 'Black Metal Frame – 8x10',
    description: 'Sleek black metal frame with glass, suitable for modern interiors and professional displays.',
    image: 'https://lh3.googleusercontent.com/d/1zt3VuXoDEzJBaiAQ4W0uq2u5RHY3sAwQ',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 5,
    name: 'Collage Frame – 5x7 (set of 3)',
    description: 'Set of three matching 5x7 frames, perfect for creating a gallery wall or a cohesive display.',
    image: 'https://lh3.googleusercontent.com/d/1-V1RFiY94_kmaWa_mmW5Nmbe1cGSwjWp',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 6,
    name: 'Gold Ornate Frame – Classic',
    description: 'Luxurious gold‑finish ornate frame, ideal for classic portraits and fine art prints.',
    image: 'https://lh3.googleusercontent.com/d/1FA1IIskQMORtKeMQzVi78HJ6SZdrQMMk',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 7,
    name: 'Gold Ornate Frame – Elegant',
    description: 'Luxurious gold‑finish ornate frame, ideal for classic portraits and fine art prints.',
    image: 'https://lh3.googleusercontent.com/d/17c90HC4FSo8MCoohAFfihic-Ezqqx5wr',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 8,
    name: 'Gold Ornate Frame – Premium',
    description: 'Luxurious gold‑finish ornate frame, ideal for classic portraits and fine art prints.',
    image: 'https://lh3.googleusercontent.com/d/1lgAL-GL9kpzgHVMbyeHJs-IfukzD190_',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 9,
    name: 'Gold Ornate Frame – Royal',
    description: 'Luxurious gold‑finish ornate frame, ideal for classic portraits and fine art prints.',
    image: 'https://lh3.googleusercontent.com/d/11_d9HBVa0b_wUG9Bx8o8Fn-sqIc9ci-y',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 10,
    name: 'Gold Ornate Frame – Vintage',
    description: 'Luxurious gold‑finish ornate frame, ideal for classic portraits and fine art prints.',
    image: 'https://lh3.googleusercontent.com/d/1kTnpriiyfB58R47LN9fpIRZiEZFYJtVr',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 11,
    name: 'Gold Ornate Frame – Heritage',
    description: 'Luxurious gold‑finish ornate frame, ideal for classic portraits and fine art prints.',
    image: 'https://lh3.googleusercontent.com/d/1_d7mIiduxSjmZ2cHYeRtxwsCacdpqDwH',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 12,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1Wn36BZ9VIIylFyAUsLNxO8x7zYCN2_m-',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 13,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1PjX0BSlkh51GZK46xJ1ggzmdGPm03VsQ',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 14,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1t0Of6FpXO5mKB2dFOskKpwDLlo4EwYvd',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 15,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1mvwBPIxfqxxVOWpb8Ds52IFhKe_9SKbG',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
   {
    id: 16,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1KDQu_d371FN985ulKheGG6MeZDs_UXN8',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
   {
    id: 17,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1YItRKrUxMsBjKFxN0Y0wnK2zoPYjAK-G',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
   {
    id: 18,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1L9pz8pjmnlfaL3OHIOF8mEYiTH806yt4',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 19,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1Xg3q9_IYbd3jOxXBk7a40ROn0bBq2hsY',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 20,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1VAU_rgzOIQ90s_YDtiAveulSEnPLgKC0',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 21,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1T2WRMVFCXlhUeosy5v_5eU7HuYb6hPBd',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 22,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1KCxz2pasTju0etXT0fLQ51e4-icf1CYU',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 23,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1hHbYBHZT7wXYSZ77keZvuwWEtXjrCbvh',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 24,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1id61Kem_NniBm-HXT3OUMvHbacfCLUd2',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 25,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1twAdVMy0Z6jL3dRIZSOdCt9-os8PIHjg',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 26,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1qOcn0NQ8qX8tfM9eMfGwOmw-ViuvL_8u',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 27,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1KCxz2pasTju0etXT0fLQ51e4-icf1CYU',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 28,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1hHbYBHZT7wXYSZ77keZvuwWEtXjrCbvh',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 29,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1rP5qcpgukzVqzNafYKObZ--3dyN_2PkF',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 30,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1QBcY_Rj3LIGqSm5jWkvXT6xca-kZ2ya9',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 31,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1gJunE9yl4OJJADvopndPymo6d0lPEAlK',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 32,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1B4iP9RstdnIpjMaawDcLKKKkXjb5f3H4',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 33,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1CLu2jbaOBImAm0PGrTPzVB9owofMDadm',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 34,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1fmaUL1t8C5LrFe1gwHD-jH1zxV6lBLpM',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
  {
    id: 35,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1qkxm_2psXtJvRKAvOcqQrXDSrBiJlYE1',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
{
    id: 36,
    name: 'Canvas Frame – 16x24',
    description: 'Stretched canvas frame ready to hang. Ideal for gallery‑style wall art or photographs.',
    image: 'https://lh3.googleusercontent.com/d/1-mebVYqy3jkdTQyPiFqYG-lHkNjesQrf',
    category: 'Wooden Frames',
    sizes: [
      { label: '16 x 20', price: 350 },
      { label: '12 x 16', price: 250 },
    ],
  },
];